import { Button } from "antd";
import { ProgramsList } from "../Programs/ProgramsList/ProgramsList";
import classes from "./SendingPortal.module.scss";
import { RoadmapComponent } from "./RoadmapComponent";
import banner from "../../assets/imgs/sending-banner.jpg";

const STEPS = [
  {
    title: "Intro Call",
    desc: "Share your goals, group size, dates, and special requirements.",
  },
  {
    title: "Program Design",
    desc: "We propose itineraries, budgets, and risk management notes.",
  },
  {
    title: "Confirm & Prep",
    desc: "Vendor confirmations, manifests, and traveler pre‑departure packets.",
  },
  {
    title: "On‑Trip Support",
    desc: "24/7 assistance and real‑time change handling during travel.",
  },
  {
    title: "Post‑Trip Review",
    desc: "Feedback, photos, and planning for the next cohort.",
  },
];

export const SendingOrganizationPortal = () => {
  return (
    <main className={`${classes.portal}`} id="main-content">
      {/* Top banner */}
      <section
        className={`${classes.banner}`}
        role="img"
        aria-label="Sunrise over mountains with a winding road"
      />

      {/* Title under banner */}

      <section
        className={`${classes.split}`}
        aria-label="Organization description"
      >
        <div className={`${classes.copy}`}>
          <header
            className={`${classes.header}`}
            aria-labelledby="sending-title"
          >
            <h2 id="sending-title" className={`${classes.title}`}>
              Sending Organization
            </h2>
            <p className={`${classes.subtitle}`}>
              Providing the Hosting Organization and the volunteer guidance
              along your ESC journey ensuring smooth, solid and fruitful
              experience for all parties.
            </p>
          </header>
          <p className={`${classes.lead}`}>
            Through the ESC Sending Program, Have A Dream supports the Egyptian
            youth in joining international volunteering projects across Europe.
            The program offers participants the chance to contribute to
            meaningful causes such as social inclusion, education, environmental
            sustainability, and cultural exchange, while developing key personal
            and professional skills. Have A Dream provides the participants with
            full guidance and support—from preparation before departure to
            ongoing mentorship during the project and reintegration upon
            return—ensuring that participants enjoy a safe, enriching, and
            transformative journey.
          </p>
        </div>
      </section>

      {/* Roadmap */}
      <section className={`${classes.roadmap}`} aria-label="Roadmap">
        <RoadmapComponent />
      </section>
      <div className={classes.secHeader} style={{ textAlign: "center" }}>
        {<h3 className={classes.title}>Available Programs</h3>}
      </div>
      <ProgramsList isSendingPortal={true} />
    </main>
  );
};

export default SendingOrganizationPortal;
